module.exports = __webpack_public_path__ + "static/media/btnbg@2x.91e4d307.png";